// import { isDoc } from '@/utils';
import {TASK_STATUS} from '@/config/enum';
// import tip from '@/utils/tip';

export const openHandler = {
  OrderAll: (row, $this) => {
    const {status} = row;
    switch (status) {
      case TASK_STATUS.UNSUBMIT:
        openHandler.OrderUnsubmit(row, $this);
        break;
      case TASK_STATUS.SUBMITED:
        openHandler.OrderSubmited(row, $this);
        break;
      case TASK_STATUS.PROCESSING:
        openHandler.OrderProcessing(row, $this);
        break;
      case TASK_STATUS.FINISHED:
        openHandler.OrderFinished(row, $this);
        break;
    }
  },
  OrderProcessing: ({id}, $this) => {
    $this.$router.push({
      name: 'OrderDetail',
      params: {id},
    });
  },
  OrderUnsubmit: ({id}, $this) => {
    // const { role } = $this.userInfo;
    // if (isDoc(role)) {
    $this.$router.push({
      name: 'OrderUnsubmitDetail',
      params: {id},
    });
    // } else {
    //   $this.$router.push({
    //     name: 'OrderDetail',
    //     params: { id },
    //   });
    // }
  },
  OrderSubmited: ({id}, $this) => {
    $this.$router.push({
      name: 'OrderDetail',
      params: {id},
    });
  },
  OrderFinished: ({id}, $this) => {
    $this.$router.push({
      name: 'OrderDetail',
      params: {id},
    });
  },
  OrderOpenStl: ({code}, $this) => {
    // $this.$router.push({
    //   name: 'OrderDetail',
    //   params: { id },
    // });
    const stlUrl = `https://mc.truesight.com.cn/?v=2&code=` + code;
    window.open(stlUrl, '_blank');
  },
  /**
   * 分派 重建组
   * @param id
   * @param $this
   * @constructor
   */
  OrderAllotGroup: ({id, processGroup}, $this) => {
    $this.$prompt('请输入重建组', '分配任务', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      inputValue: processGroup,
    }).then(({value}) => {
      if (!value) {
        value = '0';
      }
      $this.onAllotProcessGroup(id, value);
    }).catch(() => {
      $this.$message({
        type: 'info',
        message: '取消分配'
      });
    });
  },
  /**
   * 修改 重建组
   * @param id
   * @param $this
   * @constructor
   */
  OrderEditAllotGroup: ({id, processGroup}, $this) => {
    $this.$prompt('请输入重建组', '分配任务', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      inputValue: processGroup,
    }).then(({value}) => {
      if (!value) {
        value = '0';
      }
      $this.onAllotProcessGroup(id, value);
    }).catch(() => {
      $this.$message({
        type: 'info',
        message: '取消修改'
      });
    });
  },

  /**
   * 分派 重建负责人
   * @param id
   * @param $this
   * @constructor
   */
  OrderAllot: ({id, processor}, $this) => {
    $this.$prompt('请输入重建负责人姓名', '分配任务', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      inputValue: processor,
    }).then(({value}) => {
      if (!value) {
        value = '0';
      }
      $this.onAllotProcessor(id, value);
    }).catch(() => {
      $this.$message({
        type: 'info',
        message: '取消分配'
      });
    });
  },

  /**
   * 修改 重建负责人
   * @param id
   * @param $this
   * @constructor
   */
  OrderEditAllot: ({id, processor}, $this) => {
    $this.$prompt('请输入重建负责人姓名', '分配任务', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      inputValue: processor,
    }).then(({value}) => {
      if (!value) {
        value = '0';
      }
      $this.onAllotProcessor(id, value);
    }).catch(() => {
      $this.$message({
        type: 'info',
        message: '取消修改'
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/router/func.js